import { parsePhoneNumberFromString } from "libphonenumber-js";
import DateUtil from "@/utils/DateUtil";

export const valid = error => {
  return {
    is_error: error != null && error.length > 0,
    message: error
  };
};

/**
 * 電話番号のフォーマットが正しいか検証する
 * @param phoneNumber 電話番号
 */
const validateTel_jp = phoneNumber => {
  if (phoneNumber) {
    const parsedPhoneNumber = parsePhoneNumberFromString(
      "+81" + phoneNumber,
      "JA"
    );
    return parsedPhoneNumber ? parsedPhoneNumber.isValid() : false;
  } else {
    return false;
  }
};

/**
 * 入力された日付が未来日か検証する
 * @param targetDate 比較対象日付
 */
const isFutureDate = targetDate => {
  if (targetDate) {
    let today = new Date();
    let granularity = "day"
    return DateUtil.isBefore(today, targetDate, granularity);
  } else {
    return false;
  }
};

export default {
  validateTel_jp: validateTel_jp,
  isFutureDate: isFutureDate
};
